import React from "react";
import MuiIconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const icons = {
    add: <AddIcon fontSize="small" />,
    edit: <EditIcon fontSize="small" />,
    delete: <DeleteIcon fontSize="small" />,
};

const IconButton = ({ type = "add", onClick, title, className = "", ariaLabel, htmlType = "button", disabled }) => {
    const color = type === "delete" ? "error" : "primary";

    return (
        <MuiIconButton
            onClick={onClick}
            title={title || type}
            aria-label={ariaLabel || title || type}
            color={color}
            size="small"
            className={className}
            type={htmlType}
            disabled={disabled}
        >
            {icons[type]}
        </MuiIconButton>
    );
};

export default IconButton;
